import { defineComponent as _defineComponent } from 'vue';
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "muted-text" };
const _hoisted_3 = { class: "text-muted" };
const _hoisted_4 = { key: 0 };
const _hoisted_5 = { class: "text-muted" };
const _hoisted_6 = { key: 1 };
const _hoisted_7 = { class: "text-muted" };
const _hoisted_8 = { class: "mb-1 text-center text-md-right" };
import { defineComponent, ref, computed } from "vue";
import { uniq, truncate } from "lodash-es";
import { injectAppFederation } from "@/composables/injections";
import AppDialogContent from "../../AppDialogContent.vue";
import AppShowEventDetails from "@AppShows/event/AppShowEventDetails.vue";
import AppShowAddress from "@AppShows/AppShowAddress.vue";
import gql from "fraql";
const __default__ = defineComponent({
    name: "AppShowEntryBillingContacts",
    fragments: {
        eventFields: gql `
      fragment _ on Event {
        ${AppShowEventDetails.fragments.event}
      }
    `,
        registrationFields: gql `
      fragment _ on Registration {
        id
        registrantPersonId
        athletes {
          id
          name
          feiid
        }
        registrationHorses {
          id
          horseId
          horseName
        }
      }
    `,
        competitionFields: gql `
      fragment _ on Competition {
        id
        code
      }
    `,
        entryBillingContactFields: gql `
      fragment _ on Contact {
        id
        contactType

        name
        ${AppShowAddress.fragments.contactAddressFields}
        addressText
        addressHouse
        addressIndex
        addressBox
        addressCity
        addressState
        addressCountryId
        addressCountry @client {
          id
          name
        }

        organisationName
        vatCode

        billingEmail
      }
    `
    }
});
export default /*@__PURE__*/ _defineComponent({
    ...__default__,
    props: {
        event: {
            type: Object,
            required: true
        },
        registration: {
            type: Object,
            required: true
        }
    },
    setup(__props) {
        const props = __props;
        const { appFederation } = injectAppFederation();
        const textCompare = new Intl.Collator(appFederation.language, {
            sensitivity: "base"
        }).compare;
        const dialogValue = ref(false);
        const entriesWithContact = computed(() => props.registration.entries.filter(entry => !!entry.billingContact));
        const athlete = computed(() => props.registration.athletes[0]);
        const contactNames = computed(() => {
            const names = entriesWithContact.value
                .map(entry => entry.billingContact.name || entry.billingContact.organisationName)
                .sort(textCompare);
            const stringifedNames = uniq(names).join(" | ");
            return truncate(stringifedNames, {
                length: 20
            });
        });
        function billingContactName(entry) {
            switch (entry.billingContact.contactType) {
                case "ORGANISATION":
                    return entry.billingContact.organisationName;
                default:
                    return entry.billingContact.name;
            }
        }
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_divider = _resolveComponent("v-divider");
            const _component_v_row = _resolveComponent("v-row");
            return (contactNames.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps({
                        props: {
                            variant: 'text',
                            size: 'small',
                            class: 'entry-billing-contacts',
                            ariaLabel: _ctx.$t('events:appShow.billingContacts.view.alttext', 'Billing contacts for registration'),
                            onClick: () => (dialogValue.value = true)
                        },
                        contactNames: contactNames.value
                    })), () => [
                        _createVNode(_component_v_btn, {
                            variant: "text",
                            size: "small",
                            class: "entry-billing-contacts",
                            "aria-label": _ctx.$t('events:appShow.billingContacts.view.alttext', 'Billing contacts for registration'),
                            onClick: _cache[0] || (_cache[0] = () => (dialogValue.value = true))
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                    start: "",
                                    color: "black"
                                }, {
                                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                            _createTextVNode(" $iconReceipt ", -1)
                                        ]))]),
                                    _: 1
                                }),
                                _createTextVNode(" " + _toDisplayString(contactNames.value), 1)
                            ]),
                            _: 1
                        }, 8, ["aria-label"])
                    ]),
                    _createVNode(AppDialogContent, {
                        modelValue: dialogValue.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((dialogValue).value = $event)),
                        "data-test": "invoiceBillingContact"
                    }, {
                        header: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("wallet:billingContacts.preview.heading", "Billing contacts for:")), 1)
                        ]),
                        actions: _withCtx(() => [
                            _createVNode(_component_v_row, {
                                dense: "",
                                style: { "justify-content": "flex-end" }
                            }, {
                                default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_8, [
                                        _createVNode(_component_v_btn, {
                                            rounded: "",
                                            variant: "outlined",
                                            "min-width": "180px",
                                            "data-test": "dialogClose",
                                            onClick: _cache[1] || (_cache[1] = () => (dialogValue.value = false))
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t("common:ok.button", "OK")), 1)
                                            ]),
                                            _: 1
                                        })
                                    ])
                                ]),
                                _: 1
                            })
                        ]),
                        default: _withCtx(() => [
                            _createVNode(AppShowEventDetails, {
                                event: __props.event,
                                "show-logo": ""
                            }, null, 8, ["event"]),
                            _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entriesWithContact.value, (entry, index) => {
                                return (_openBlock(), _createElementBlock("div", { key: index }, [
                                    _createElementVNode("div", null, _toDisplayString(athlete.value.name) + " " + _toDisplayString(athlete.value.feiid ? " | " + athlete.value.feiid : ""), 1),
                                    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.registration.registrationHorses.map(x => x.horseName).join(", ")) + ": " + _toDisplayString(entry.competition.code), 1),
                                    _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
                                    _createElementVNode("div", null, [
                                        _createElementVNode("div", null, [
                                            _createElementVNode("b", _hoisted_3, _toDisplayString(_ctx.$t("wallet:billingContacts.preview.invoicedTo.subheading", "Invoiced to:")), 1),
                                            _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
                                            _createTextVNode(" " + _toDisplayString(billingContactName(entry)) + " ", 1),
                                            _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
                                            _createVNode(AppShowAddress, {
                                                address: entry.billingContact,
                                                "break-up": ""
                                            }, null, 8, ["address"]),
                                            _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1))
                                        ]),
                                        (entry.billingContact.vatCode)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                                _createElementVNode("b", _hoisted_5, _toDisplayString(_ctx.$t("wallet:billingContacts.preview.VATNumber.label", "VAT number:")), 1),
                                                _createTextVNode(" " + _toDisplayString(entry.billingContact.vatCode), 1)
                                            ]))
                                            : _createCommentVNode("", true),
                                        _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
                                        (entry.billingContact.billingEmail)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                                _createElementVNode("b", _hoisted_7, _toDisplayString(_ctx.$t("wallet:billingContacts.preview.emailForBilling.label", "E-mail for billing messages:")), 1),
                                                _createTextVNode(" " + _toDisplayString(entry.billingContact.billingEmail), 1)
                                            ]))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
                                    (entriesWithContact.value.length - 1 != index)
                                        ? (_openBlock(), _createBlock(_component_v_divider, { key: 0 }))
                                        : _createCommentVNode("", true),
                                    _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1))
                                ]));
                            }), 128))
                        ]),
                        _: 1
                    }, 8, ["modelValue"])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
